import { HelpText } from 'react-rainbow-components';
import getMetricInfo from '../../helpers/getMetricInfo';
import {
    BusinessHealthResponse,
} from '../../types';
import formatMetricSnapshot from './formatMetricSnapshot';
import {
    HealthMetricHelpWrap,
    MetricLabel,
    MetricRow,
} from './styled';
import getLabels from '../../BusinessHealthWidget/helpers/getLabels';

export interface InsightPrimaryMetricsProps {
    data?: BusinessHealthResponse;
    primaryMetrics: string[];
}

const InsightPrimaryMetrics = ({
    data,
    primaryMetrics,
}: InsightPrimaryMetricsProps) => {
    const metrics = data?.metrics;
    return (
        <>
            {primaryMetrics.map((metricKey) => {
                const def = getMetricInfo(metricKey);
                const labels = getLabels(metricKey, data);
                // eslint-disable-next-line max-len
                const label = labels?.label ?? labels?.label_short ?? def?.shortLabel ?? def?.label ?? metricKey;
                const description = labels?.description ?? def?.description ?? '';
                const snapshot = metrics?.[metricKey];
                return (
                    <MetricRow key={metricKey}>
                        <MetricLabel>
                            {label}
                            {description ? (
                                <HealthMetricHelpWrap>
                                    <HelpText text={description} iconSize="small" />
                                </HealthMetricHelpWrap>
                            ) : null}
                        </MetricLabel>
                        {formatMetricSnapshot(metricKey, snapshot)}
                    </MetricRow>
                );
            })}
        </>
    );
};

export default InsightPrimaryMetrics;
